/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IContentBlockViewProps } from './farmlands-carousel-content-block';

const ContentBlockView: React.FC<IContentBlockViewProps> = (props) => {
    const {
        contentBlockContainer,
        imageContainer,
        detailsDesktopContainer,
        detailsMobileContainer,
        title,
        text,
        links,
        image,
        contentBlockAnchorTag,
        imageLink,
        imageAriaLabel,
        shouldOpenLinkInNewTab
    } = props;

    if (imageLink) {
        return (
            <Module {...contentBlockContainer}>
                <Node
                    {...contentBlockAnchorTag}
                    href={imageLink}
                    {...(shouldOpenLinkInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : null)}
                    className={contentBlockAnchorTag ? contentBlockAnchorTag.className : ''}
                    aria-label={imageAriaLabel}
                >
                    <Node {...imageContainer}>
                        {image}
                        <Node {...detailsDesktopContainer}>
                            {title}
                            {text}
                            {links}
                        </Node>
                    </Node>
                    <Node {...detailsMobileContainer}>
                        {title}
                        {text}
                        {links}
                    </Node>
                </Node>
            </Module>
        );
    } else {
        return (
            <Module {...contentBlockContainer}>
                <Node {...imageContainer}>
                    {image}
                    <Node {...detailsDesktopContainer}>
                        {title}
                        {text}
                        {links}
                    </Node>
                </Node>
                <Node {...detailsMobileContainer}>
                    {title}
                    {text}
                    {links}
                </Node>
            </Module>
        );
    }
};

export default ContentBlockView;
